import {
  Message
} from 'element-ui'
import {
  errorCode
} from '@/config'

export function formatTime(second) {
  let m = Math.floor(second / 60)
  let s = second - m * 60
  m = m < 10 ? '0' + m : m + ''
  s = s < 10 ? '0' + s : s + ''
  return m + ':' + s
}

export function htmlEncodeByRegExp(str) {
  let s = "";
  if (str.length == 0) return "";
  s = str.replace(/&/g, "&amp;");
  s = s.replace(/</g, "&lt;");
  s = s.replace(/>/g, "&gt;");
  s = s.replace(/ /g, "&nbsp;");
  s = s.replace(/\'/g, "&#39;");
  s = s.replace(/\"/g, "&quot;");
  return s;
}
export function htmlDecodeByRegExp(str) {
  let s = '', repNum = 0;
  if(str){
    if (str.length === 0) return ''
    s = str.replace(/&amp;/g,"&")
    s = s.replace(/&lt;/g,"<")
    s = s.replace(/&gt;/g,">")
    s = s.replace(/&nbsp;/g," ")
    s = s.replace(/<br\/>/g,"")
    s = s.replace(/<stong\/>/g,"")
    s = s.replace(/&#39;/g,"\'")
    s = s.replace(/&quot;/g,"\"")
    s = s.replace(/___\d___/g,(s,i)=>{
      repNum++
      return  '<span class="fill-mark"><em>______</em><i>'+repNum+'</i></span>'
    })
    // s = s.replace(/______/g,(s,i)=>{
    //   repNum++
    //   return  '<span class="fill-mark"><em>______</em><i>'+repNum+'</i></span>'
    // })
    s = s.replace(/\#\#\$\$\#\#/g,(s,i)=>{
      repNum++
      return  '<span class="fill-mark"><em>______</em><i>'+repNum+'</i></span>'
    })
    return s
  }
}
export function arrSortToString(arr, sort = false) {
  let str = ''
  if (!sort) {
    arr.forEach(item => {
      if (typeof item === 'object') {
        str += arrSortToString(item, true)
      } else {
        str += item.toString()
      }
    })
  } else {
    arr.sort().forEach(item => {
      if (typeof item === 'object') {
        str += arrSortToString(item, true)
      } else {
        str += item.toString()
      }
    })
  }

  return str
}
export function answerFormat(arr) {
  let str = ''
  arr.slice().forEach(item => {
    str += item[0].content + ';'
  })
  return str.slice(0, -1)
}

export function getQueryString(name) {
  var search = window.location.href.split('?')[1]
  if (search) {
    var params = search.split('&')
    var obj = {}

    for (var i = 0, l = params.length; i < l; i++) {
      var tmp = params[i].split('=')
      obj[tmp[0]] = tmp[1]
    }

    return obj[name] || "";
  }
  return ""
}

export function rem(win) {
  function resize() {
    var domWidth = domEle.getBoundingClientRect().width;
    if (domWidth / v > 540) {
      domWidth = 540 * v;
    }
    win.rem = domWidth / 16;
    domEle.style.fontSize = win.rem + "px";
  }
  var v, initial_scale, timeCode, dom = win.document,
    domEle = dom.documentElement,
    viewport = dom.querySelector('meta[name="viewport"]'),
    flexible = dom.querySelector('meta[name="flexible"]');
  if (viewport) {
    var o = viewport.getAttribute("content").match(/initial\-scale=(["']?)([\d\.]+)\1?/);
    if (o) {
      initial_scale = parseFloat(o[2]);
      v = parseInt(1 / initial_scale);
    }
  } else if (flexible) {
    var o = flexible.getAttribute("content").match(/initial\-dpr=(["']?)([\d\.]+)\1?/);
    if (o) {
      v = parseFloat(o[2]);
      initial_scale = parseFloat((1 / v).toFixed(2))
    }
  }
  if (!v && !initial_scale) {
    var n = (win.navigator.appVersion.match(/android/gi), win.navigator.appVersion.match(/iphone/gi));
    v = win.devicePixelRatio;
    v = n ? v >= 3 ? 3 : v >= 2 ? 2 : 1 : 1, initial_scale = 1 / v
  }
  //没有viewport标签的情况下
  if (domEle.setAttribute("data-dpr", v), !viewport) {
    if (viewport = dom.createElement("meta"), viewport.setAttribute("name", "viewport"), viewport.setAttribute("content", "initial-scale=" + initial_scale + ", maximum-scale=" + initial_scale + ", minimum-scale=" + initial_scale + ", user-scalable=no"), domEle.firstElementChild) {
      domEle.firstElementChild.appendChild(viewport)
    } else {
      var m = dom.createElement("div");
      m.appendChild(viewport), dom.write(m.innerHTML)
    }
  }
  win.dpr = v;
  win.addEventListener("resize", function () {
    clearTimeout(timeCode), timeCode = setTimeout(resize, 300)
  }, false);
  win.addEventListener("pageshow", function (b) {
    b.persisted && (clearTimeout(timeCode), timeCode = setTimeout(resize, 300))
  }, false);
  resize();
}

export function isArray(obj) {
  if (Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object array]') {
    return true
  }
  return false
}

export function isObject(obj) {
  if (Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object object]') {
    return true
  }
  return false
}

export function isString(obj) {
  if (Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object string]') {
    return true
  }
  return false
}

export function showErrMessage(e, msg) {
  let m = ''

  if (isObject(e)) {
    m = errorCode[e.code] ? e.msg : '网络错误'
  } else {
    m = msg
  }

  if(typeof m != 'undefined'){
    Message({
      message: m,
      type: 'error',
      duration: 3 * 1000
    })
  }
  console.log(msg)
  console.log(e)
}

export function isM3u8(url) {
  return /\.m3u8$/.test(url)
}

export function getVideoSourceOption(url) {
  let sourceObj = {}
  if (isM3u8(url)) {
    sourceObj = {
      type: 'application/x-mpegURL'
    }
  } else {
    sourceObj = {
      type: 'video/mp4'
    }
  }

  return Object.assign({}, sourceObj, {
    src: url
  })
}

export function debounce(func, wait, immediate) {

  var timeout;

  return function () {
    var context = this;
    var args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      // 如果已经执行过，不再执行
      var callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait)
      if (callNow) func.apply(context, args)
    }
    else {
      timeout = setTimeout(function () {
        func.apply(context, args)
      }, wait);
    }
  }
}

export function isAndroid() {
  let res;
  if (/(Android)/i.test(navigator.userAgent)) {
    // 安卓机
    res = true;
  } else {
    res = false
  }
  return res;
}

export function isPkgCode(code){
  return [8930003, 8930004, 8930005, 8930006, 8930007].includes(code)
}


export function formatTimeUpgrade(second) {
  let m = Math.floor(second / 60)
  let s = second - m * 60
  m = m < 10 ? '0' + m : m + ''
  s = s < 10 ? '0' + s : s + ''
  return m + '<span>分</span>' + s +'<span>秒</span>'
}

export function userAnswerFormat(arr) {
  let str = ''
  arr.slice().forEach(item => {
    str += item + ';'
  })
  return str.slice(0, -1)
}

export function formatTimeTest(second) {
  let m = Math.floor(second / 60)
  let s = second - m * 60
  m = m < 10 ? '0'+m : m+''
  s = s < 10 ? '0'+s : s+''
  return m + ':' + s + '分'
}

export function formatTimeSecond(time) {
  let m = Math.floor(time / 60)
  let s = time - m * 60
  m = m < 10 ? '0'+m : m+''
  s = s < 10 ? '0'+s : s+''
  return m + ':' + s ;
}
export function formatTimeTests(second) {
  let m = Math.floor(second / 60)
  let s = second - m * 60
  m = m < 10 ? '0'+m : m+''
  s = s < 10 ? '0'+s : s+''
  return m + '分' + s + '秒'
}

export function uniqueArrary(arr) {//数组的去重
  const res = new Map();
  return arr.filter((a) => !res.has(a) && res.set(a, 1))
}

export function formatBit(val){
  val = +val
  return val > 9 ? val : '0' + val
}
export function transformTime(timestamp) {
  if (timestamp) {
    let time = new Date(timestamp);
    let y = time.getFullYear();
    let M = time.getMonth() + 1;
    let d = time.getDate();
    M = M < 10 ? '0' + M : M;
    d = d < 10 ? '0' + d : d;
    return y + '/' + M + '/' + d;
  } else {
    return '';
  }
}

export function htmlspecialchars(str){
  let s = "";
  if (str.length == 0) return "";
  for   (let i = 0; i < str.length; i++)
  {
    switch (str.substr(i,1))
    {
      case "<": s += "&lt;"; break;
      case ">": s += "&gt;"; break;
      case "&": s += "&amp;"; break;
      case " ":
        if(str.substr(i + 1, 1) == " "){
          s += " &nbsp;";
          i++;
        } else s += " ";
        break;
      case "\"": s += "&quot;"; break;
      case "\n": s += "<br>"; break;
      default: s += str.substr(i,1); break;
    }
  }
  return s;
}
export function htmlspecialchars_decode(str){
  str = str.replace(/&amp;/g, '&');
  str = str.replace(/&lt;/g, '<');
  str = str.replace(/&gt;/g, '>');
  str = str.replace(/&quot;/g, "''");
  str = str.replace(/&#039;/g, "'");
  return str;
}
export function htmlspecialcharsDecode(string, quote_style) {
  let optTemp = 0,
    i = 0,
    noquotes = false;
  if (typeof quote_style === 'undefined') {
    quote_style = 2;
  }
  string = string.toString()
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>');
  let OPTS = {
    'ENT_NOQUOTES': 0,
    'ENT_HTML_QUOTE_SINGLE': 1,
    'ENT_HTML_QUOTE_DOUBLE': 2,
    'ENT_COMPAT': 2,
    'ENT_QUOTES': 3,
    'ENT_IGNORE': 4
  };
  if (quote_style === 0) {
    noquotes = true;
  }
  if (typeof quote_style !== 'number') {
    // Allow for a single string or an array of string flags
    quote_style = [].concat(quote_style);
    for (i = 0; i < quote_style.length; i++) {
      // Resolve string input to bitwise e.g. 'PATHINFO_EXTENSION' becomes 4
      if (OPTS[quote_style[i]] === 0) {
        noquotes = true;
      } else if (OPTS[quote_style[i]]) {
        optTemp = optTemp | OPTS[quote_style[i]];
      }
    }
    quote_style = optTemp;
  }
  if (quote_style & OPTS.ENT_HTML_QUOTE_SINGLE) {
    string = string.replace(/&#0*39;/g, "'"); // PHP doesn't currently escape if more than one 0, but it should
    // string = string.replace(/&apos;|&#x0*27;/g, "'"); // This would also be useful here, but not a part of PHP
  }
  if (!noquotes) {
    string = string.replace(/&quot;/g, '"');
  }
  // Put this in last place to avoid escape being double-decoded
  string = string.replace(/&amp;/g, '&');

  console.log(string)
  return string;

}
export function isEmpty(obj){
  if(typeof obj == "undefined" || obj == null || obj == ""){
    return true;
  }else{
    return false;
  }
}
export function filterHTMLTag (str) {
  str = str.replace(/<[^>]+>|&[^>]+;/g, '').trim()// 去掉所有的html标签和&nbsp;之类的特殊符合
  str = str.replace(/\s/g, '')
  return str
}
export function getCurrentTime () {
  let date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()

  let hour = date.getHours()
  let minute = date.getMinutes()
  let second = date.getSeconds()

  if (hour < 10) {
    hour = '0' + hour
  }

  if (minute < 10) {
    minute = '0' + minute
  }

  if (second < 10) {
    second = '0' + second
  }

  return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
}

export function getUserMessageKey () {
  let s = localStorage.getItem('UserInfo')
  let userInfo = JSON.parse(s)
  let userId = userInfo['userId']
  let topicId = userInfo['topicId']
  let currentQuestionId = localStorage.getItem('currentQuestionId')
  return {userId, topicId, currentQuestionId}
}

export function diffTimeFormat (dateDiff) {
  let diffStr = ''
  let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)) // 计算出相差天数
  let leave1 = dateDiff % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  let hours = Math.floor(leave1 / (3600 * 1000)) // 计算出小时数
  // 计算相差分钟数
  let leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  let minutes = Math.floor(leave2 / (60 * 1000)) // 计算相差分钟数
  // 计算相差秒数
  let leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  let seconds = Math.round(leave3 / 1000)
  if (dayDiff > 0) {
    diffStr += dayDiff + '天'
  }

  if (hours > 0) {
    diffStr += hours + '小时'
  }

  if (minutes > 0) {
    diffStr += minutes + '分'
  }

  if (seconds > 0) {
    diffStr += seconds + '秒'
  }
  return diffStr
}
export function isSSAI () {
  return /SSAI_Android|SSAI_iOS$/.test(navigator.userAgent)
}
export const disableBrowserBack = (param) => {
       return (function () {
           history.pushState(null, null, document.URL);
           if (window.history && window.history.pushState) {
               $(window).on('popstate', function () {
                   window.history.pushState('forward', null, '');
                   window.history.forward(1);
              });
          }
          //
         window.history.pushState('forward', null, '');
         window.history.forward(1);
      })()
  };



// WEBPACK FOOTER //
// ./src/utils/index.js